// Origem da visita (utm_source), guardada só na sessão do navegador.
// Sem cookie e sem dado pessoal: serve para a mensagem do WhatsApp dizer de onde a pessoa veio.

const ORIGEM_KEY = 'origem';

const REDES: Record<string, string> = {
  youtube: 'YouTube',
  instagram: 'Instagram',
  tiktok: 'TikTok',
};

export const WHATSAPP_FIXO = '551144414782';
export const WHATSAPP_CELULAR = '5511984763658';

// Chamado uma vez, antes do primeiro render.
export const capturarOrigem = () => {
  const fonte = new URLSearchParams(window.location.search).get('utm_source');
  if (!fonte) return;
  try {
    sessionStorage.setItem(ORIGEM_KEY, fonte.trim().toLowerCase().slice(0, 40));
  } catch {
    // sessionStorage indisponível (modo privado, bloqueio): segue sem origem
  }
};

export const lerOrigem = (): string | null => {
  try {
    return sessionStorage.getItem(ORIGEM_KEY);
  } catch {
    return null;
  }
};

export const whatsappHref = (numero: string = WHATSAPP_FIXO) => {
  const rede = REDES[lerOrigem() ?? ''];
  const mensagem = `Olá, Eliane! Vim pelo ${rede ?? 'site'} e gostaria de conversar um pouquinho sobre o atendimento.`;
  return `https://wa.me/${numero}?text=${encodeURIComponent(mensagem)}`;
};

// Evento para o GTM/GA4. Só chega ao Google se a pessoa aceitou os cookies (o GTM nem carrega antes).
export const registrarCliqueWhatsApp = (local: string) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'whatsapp_click',
    origem: lerOrigem() ?? 'direto',
    local_clique: local,
  });
};
